<template>
    <div class="profile-card">
        <ProfileCardHeaderInternal
            :availability="profile.availability_status"
            :avatar-url="profile.avatar_url"
            :score="profile.percentage_score_avg"
            :profile="profile"
        />
        <ProfileCardScores
            :scores="profile.scores"
            :main-filters="mainFilters"
        />
        <ProfileCardButton :profile="profile" />
        <ProfileCardButtonInternal
            :text="'Matchmaker-Profil öffnen'"
            :link="profile.view_profile_url"
            :profile="profile"
        />
        <ProfileCardButtonInternal
            :text="'CV-Datei öffnen'"
            :pdf="profile.cv_url"
            :profile="profile"
            @openPdf="handleOpenPdf"
        />
        <ProfileCardManagerProfileButton
            v-if="profile.web_profile_url"
            :url="profile.web_profile_url"
        />
        <Collapse
            v-show="profile.content_job_scorings.length"
            :title="
                $trans(
                    'web_search.profile_card.relevant_professional_experience',
                )
            "
        >
            <ProfileJobCompetenceScoring :data="profile.content_job_scorings" />
        </Collapse>
        <Collapse
            v-show="profile.content_industry_scorings.length"
            :title="
                $trans('web_search.profile_card.relevant_industry_experience')
            "
        >
            <ProfileIndustryCompetenceScoring
                :data="profile.content_industry_scorings"
            />
        </Collapse>
        <Collapse
            v-show="profile.content_qualifications.length"
            :title="$trans('web_search.profile_card.qualifications')"
        >
            <ProfileQualifications :data="profile.content_qualifications" />
        </Collapse>
        <Collapse
            v-show="profile.content_publications.length"
            :title="$trans('web_search.profile_card.publications')"
        >
            <ProfilePublications :data="profile.content_publications" />
        </Collapse>
        <div class="profile-footer">
            Kandidat bereitgestellt von
            <a :href="link" class="profile-link" target="_blank">{{
                linkText
            }}</a>
        </div>
    </div>
</template>

<script>
import Collapse from "../Utils/Collapse.vue";
import ProfileCardButton from "./ProfileCardButton.vue";
import ProfileCardButtonInternal from "./ProfileCardButtonInternal.vue";
import ProfileCardHeaderInternal from "./ProfileCardHeaderInternal.vue";
import ProfileCardManagerProfileButton from "./ProfileCardManagerProfileButton.vue";
import ProfileCardScores from "./ProfileCardScores.vue";
import ProfileIndustryCompetenceScoring from "./ProfileIndustryCompetenceScoring.vue";
import ProfileJobCompetenceScoring from "./ProfileJobCompetenceScoring.vue";
import ProfileQualifications from "./ProfileQualifications.vue";
import ProfilePublications from "./ProfilePublications.vue";

export default {
    components: {
        Collapse,
        ProfileCardButton,
        ProfileCardButtonInternal,
        ProfileCardHeaderInternal,
        ProfileCardManagerProfileButton,
        ProfileCardScores,
        ProfileJobCompetenceScoring,
        ProfileIndustryCompetenceScoring,
        ProfileQualifications,
        ProfilePublications,
    },
    props: {
        profile: {
            type: Object,
            required: true,
        },
        mainFilters: {
            type: Array,
            required: true,
        },
    },
    emits: ["openPdf"],
    data() {
        return {
            pdfModalVisible: false,
            pdfUrl: "",
        };
    },
    computed: {
        linkText() {
            if (this.profile.pool_partner_name) {
                return this.profile.pool_partner_name;
            }

            switch (this.profile.group_id) {
                case 1:
                    return "Deutsche Interim AG";
                case 30:
                    return "Swiss Interim";
                case 32:
                    return "Matchmaker";
                default:
                    return "Matchmaker";
            }
        },

        link() {
            if (this.profile.pool_partner_url) {
                return this.profile.pool_partner_url;
            }

            switch (this.profile.group_id) {
                case 1:
                    return "https://www.deutscheinterim.com";
                case 30:
                    return "https://www.swissinterim.com";
                case 32:
                    return "https://www.matchmaker.de";
                default:
                    return "https://www.matchmaker.de";
            }
        },
    },
    methods: {
        handleOpenPdf(url) {
            this.$emit("openPdf", url);
        },
    },
};
</script>

<style scoped>
.profile-card {
    color: #000;
    width: 400px;
    border-radius: 8px;
    padding: 20px;
    box-sizing: border-box;
    background: white;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid #bcbab6;
}

.profile-footer {
    margin-bottom: -25px;
    margin-top: -10px;
    font-size: 14px;
    text-align: right;
    font: italic normal normal 15px/55px Barlow;
    letter-spacing: -0.36px;
    color: #8e8d8c;
}

.profile-link {
    text-align: right;
    font: italic normal normal 15px/55px Barlow;
    letter-spacing: -0.36px;
    color: #8e8d8c;
    opacity: 1;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .profile-footer {
        font: italic normal normal 13px/55px Barlow;
    }

    .profile-link {
        font: italic normal normal 15px/55px Barlow;
    }
}
</style>
